/**
 * Classify a prepared drop into the workspace's four display categories.
 * Reads only `status` + `executeAfter`; `refMs` is the "now" reference used to
 * split still-in-the-future SENT drops (scheduled) from already-sent ones.
 * Single source of truth for both the Sent-tab sections and the Reinstate filter.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { PreparedDrop } from '@/hooks';

export type PreparedDropCategory = 'draft' | 'sent' | 'scheduled' | 'killed';

export function classifyPreparedDrop(drop: PreparedDrop, refMs: number): PreparedDropCategory {
  if (drop.status === 'KILLED') return 'killed';
  if (drop.status === 'DRAFT') return 'draft';
  // SENT: a future executeAfter means it's still queued (scheduled); else it went out.
  const exec = drop.executeAfter ? new Date(drop.executeAfter).getTime() : 0;
  if (exec && !Number.isNaN(exec) && exec > refMs) return 'scheduled';
  return 'sent';
}
